import snakeCase from 'lodash-es/snakeCase'

import type {ExportableConversation, ExportableMessage} from './types'

function roleHeading(message: ExportableMessage, user: string | undefined): string {
  if (message.role === 'user') return user ? `## @${user}` : '## User'
  if (message.role === 'assistant') return '## Copilot'
  return `## ${message.role}`
}

export function formatAsJson(conversation: ExportableConversation): string {
  const {title, url, participants, messages} = conversation
  const payload = {
    title,
    ...(url ? {url} : {}),
    ...(participants ? {participants} : {}),
    messages,
  }
  return JSON.stringify(payload, null, 2)
}

export function formatAsMarkdown(conversation: ExportableConversation): string {
  const {title, url, participants, messages} = conversation
  const user = participants?.user

  const metadata: string[] = []
  if (user) metadata.push(`**User:** @${user}`)
  if (url) metadata.push(`**URL:** ${url}`)

  const header = metadata.length > 0 ? `# ${title}\n\n${metadata.join('\n')}` : `# ${title}`

  const body = messages.map(message => `${roleHeading(message, user)}\n\n${message.content}\n`).join('\n')

  return `${header}\n\n${body}`
}

/** Build the export filename stem, e.g. `mon_jan_01_2024_my_chat`. */
export function exportFilenameStem(title: string): string {
  return snakeCase(`${new Date().toDateString()} ${title}`)
}
